module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product form-page"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    staticClass: "product-main"
  }, [_c('group', {
    attrs: {
      "title": "指定授权经办人",
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "transactorName",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "姓名",
      "is-type": "china-name",
      "placeholder": "请输入姓名",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.data.transactorName),
      callback: function($$v) {
        _vm.$set(_vm.data, "transactorName", $$v)
      },
      expression: "data.transactorName"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "transactorCertigicateType",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件类型",
      "text-align": _vm.type === 0 ? 'right' : '',
      "placeholder": "请输入证件类型",
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.data.transactorCertigicateType),
      callback: function($$v) {
        _vm.$set(_vm.data, "transactorCertigicateType", $$v)
      },
      expression: "data.transactorCertigicateType"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "transactorCertigicateNo",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件号码",
      "is-type": _vm.isIdCard,
      "placeholder": "请输入证件号码",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    on: {
      "on-change": _vm.idcardChange
    },
    model: {
      value: (_vm.data.transactorCertigicateNo),
      callback: function($$v) {
        _vm.$set(_vm.data, "transactorCertigicateNo", $$v)
      },
      expression: "data.transactorCertigicateNo"
    }
  }), _vm._v(" "), _c('popup-radio', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "text-align": _vm.type === 0 ? 'right' : '',
      "title": "证件有效期",
      "options": ['永久有效', '存在有效期']
    },
    model: {
      value: (_vm.localValidity),
      callback: function($$v) {
        _vm.localValidity = $$v
      },
      expression: "localValidity"
    }
  }), _vm._v(" "), (_vm.localValidity === '存在有效期') ? _c('datetime', {
    ref: "transactorCertificateValidity",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "有效期",
      "min-year": 2000,
      "max-year": 2099,
      "text-align": _vm.type === 0 ? 'right' : '',
      "readonly": _vm.type === 0
    },
    model: {
      value: (_vm.data.transactorCertificateValidity),
      callback: function($$v) {
        _vm.$set(_vm.data, "transactorCertificateValidity", $$v)
      },
      expression: "data.transactorCertificateValidity"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('selector', {
    style: ({
      color: _vm.type === 0 ? 'rgba(0, 0, 0, 0.3)' : '',
      height: _vm.type === 0 ? '30px' : '50px'
    }),
    attrs: {
      "title": "性别",
      "options": ['男', '女'],
      "placeholder": "请选择性别",
      "readonly": ""
    },
    model: {
      value: (_vm.data.transactorSex),
      callback: function($$v) {
        _vm.$set(_vm.data, "transactorSex", $$v)
      },
      expression: "data.transactorSex"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "transactorAge",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "年龄",
      "type": "number",
      "placeholder": "请输入年龄",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.data.transactorAge),
      callback: function($$v) {
        _vm.$set(_vm.data, "transactorAge", $$v)
      },
      expression: "data.transactorAge"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "transactorPosition",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "职务",
      "placeholder": "请输入职务",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.transactorPosition),
      callback: function($$v) {
        _vm.$set(_vm.data, "transactorPosition", $$v)
      },
      expression: "data.transactorPosition"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "transactorLandline",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电话(座机)",
      "max": 20,
      "keyboard": "number",
      "is-type": _vm.isPhone,
      "placeholder": "请输入座机",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0
    },
    model: {
      value: (_vm.data.transactorLandline),
      callback: function($$v) {
        _vm.$set(_vm.data, "transactorLandline", $$v)
      },
      expression: "data.transactorLandline"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "transactorMobile",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电话(手机)",
      "max": 11,
      "keyboard": "number",
      "is-type": "china-mobile",
      "placeholder": "请输入手机号码",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.transactorMobile),
      callback: function($$v) {
        _vm.$set(_vm.data, "transactorMobile", $$v)
      },
      expression: "data.transactorMobile"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "transactorEmail",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电子邮箱",
      "is-type": "email",
      "placeholder": "请输入电子邮箱",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0
    },
    model: {
      value: (_vm.data.transactorEmail),
      callback: function($$v) {
        _vm.$set(_vm.data, "transactorEmail", $$v)
      },
      expression: "data.transactorEmail"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "6em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "transactorOfficeZip",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "办公邮编",
      "max": 6,
      "type": "number",
      "placeholder": "请输入办公邮编",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.transactorOfficeZip),
      callback: function($$v) {
        _vm.$set(_vm.data, "transactorOfficeZip", $$v)
      },
      expression: "data.transactorOfficeZip"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "transactorOfficeAddress",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "办公地址",
      "placeholder": "请输入办公地址",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.transactorOfficeAddress),
      callback: function($$v) {
        _vm.$set(_vm.data, "transactorOfficeAddress", $$v)
      },
      expression: "data.transactorOfficeAddress"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "transactorProductRelation",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "与该机构/产品的关系",
      "placeholder": "请输入与该机构/产品的关系",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.transactorProductRelation),
      callback: function($$v) {
        _vm.$set(_vm.data, "transactorProductRelation", $$v)
      },
      expression: "data.transactorProductRelation"
    }
  })], 1)], 1), _vm._v(" "), _c('submit-button', {
    on: {
      "click": _vm.$_product_auth
    }
  }, [_vm._v("下一步")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ee3dfa5"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InvestorInfo/Product/Two.vue
// module id = 1051
// module chunks = 1